const messages = {
  threads: {
    orders: { title: "", content: "" },
    externalTraining: { title: "", content: "" },
    InvestmentSupport: { title: "", content: "" },
    onlineTraining: { title: "", content: "" },
    bTraining: { title: "", content: "" },
    hunter: { title: "", content: "" },
    profileComplete: { title: "", content: "" },
    activeUser: { title: "", content: "" },
    deleteItemFromOrder: { title: "", content: "" },
    deleteOrder: { title: "", content: "" },
    commitmentLetter: {
      title: "Dėkojame, kad užsiregistravote!",
      content:
        "Gerbiama(s),<br/>Dėkojame, kad užsiregistravote. Su malonumu pranešame, kad Jūsų registracija BRIDGESTONE PLUS buvo peržiūrėta ir patvirtinta. Linkime, kad BRIDGESTONE PLUS atneštų jums sėkmę bei vertingų galimybių ir tikimės tolesnio bendradarbiavimo.<br/>Su geriausiais linkėjimais,<br/>BRIDGESTONE PLUS komanda",
    },
    uberall: { title: "", content: "" },
    welcome: {
      title: "Dėkojame, kad užsiregistravote!",
      content:
        "Gerbiama(s),<br/>Dėkojame, kad užsiregistravote. Su malonumu pranešame, kad Jūsų registracija BRIDGESTONE PLUS buvo peržiūrėta ir patvirtinta. Linkime, kad BRIDGESTONE PLUS atneštų jums sėkmę bei vertingų galimybių ir tikimės tolesnio bendradarbiavimo.<br/>Su geriausiais linkėjimais,<br/>BRIDGESTONE PLUS komanda",
    },
    booster: { title: "", content: "" },
    orderStatus_RETURNED: { title: "", content: "" },
    orderStatus_REJECTED: { title: "", content: "" },
    kickbackPayback: { title: "", content: "" },
    survey_thankyou: { title: "", content: "" },
    survey: { title: "", content: "" },
    salesPromotions: { title: "", content: "" },
  },
};

export default {
  messages,
};
